import React from 'react';

export const Loading: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
  return (
    <div className="admin-loading">
      <div style={{ textAlign: 'center' }}>
        <div className="admin-spinner" />
        <p style={{ marginTop: 16, color: 'var(--admin-text-muted)' }}>{message}</p>
      </div>
    </div>
  );
};

export default Loading;
